export default __webpack_public_path__ + "static/media/loader.2bcd86e5.gif";